import React from "react";
import { Typography, Grid } from "@material-ui/core";
import ExportButtons from "./ExportButtons";

/**
 * Component that renders a page for exporting commissions data.
 * The component uses the `useCommissionContext` hook to get the export functions
 * and status information.
 *
 * The component renders a grid of 1 column, with a single card containing a
 * button to export the commissions data. The button is disabled while the
 * export is in progress.
 *
 * The component also renders a linear progress bar below each button, showing the
 * progress of the export.
 */
export default function ExportTab() {
  return (
    <div>
      <Typography variant="h5" gutterBottom>
        Export Commission Data
      </Typography>
      <Typography variant="body2" color="textSecondary" paragraph>
        Export various commission reports for processing and record keeping.
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <ExportButtons />
        </Grid>
      </Grid>
    </div>
  );
}
